import styled from 'styled-components';

export const OrderFilterPeriodStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
